import { collection, findSelector, resource } from "data/helpers/apiv3";
import { Club } from "data/records";

const [api, actions] = resource(Club, [
  collection.get("privilegedClubsForUser", ["userId", "managesMembers", "managesBilling", "managesRoutes", "admin"]),
]);

const selectors = {
  ...findSelector(Club),
  byUserId: (state, userId) => state.apiv3.club.id.filter((c) => c.userId === userId).first(),
  bySlug: (state, slug) => state.apiv3.club.id.filter((c) => c.slug === slug).first(),
};

const reducers = {};

const initialState = {};

export {
  api as clubApi,
  actions as clubActions,
  selectors as clubSelectors,
  reducers as clubReducers,
  initialState as clubInitialState,
};
